module.exports = __webpack_public_path__ + "static/img/rnd1.b86b8e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/rnd1.png
// module id = 1260
// module chunks = 0